<template>
    <div class="otherIp">
        <el-tag
            :key="tag"
            v-for="tag in other_ip_data1"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag}}
        </el-tag>
        <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
        >
        </el-input>
        <el-button v-else class="otherIpNew" size="small" @click="showInput">添加其他IP</el-button>

    </div>
</template>

<script>
    export default {
        props:{
            data:Array,
            getData:Function,
            type:String
        },
        data() {
            return {
                other_ip_data1: [], //字符串形式
                other_ip_data2: [], //对象形式
                inputVisible: false,
                inputValue: '',
                refresh:false
            };
        },
        watch:{
            data(){
                // console.log(1);
                if (!this.refresh) {
                    this.getOtherIpData()
                    this.refresh=true
                }
            }
        },
        created(){
            // this.refresh=true
        },
        mounted(){
            // this.refresh=true
        },
        methods: {
            getOtherIpData(){
                if (this.type=='edit'){
                    let handleData=this.data.map(item=> item.ip+'/'+item.hostname)
                    this.other_ip_data1=handleData   //字符串形式
                    this.other_ip_data2=this.data    //对象形式
                    // console.log(this.other_ip_data1);
                    // console.log(this.other_ip_data2);
                }
            },
            handleClose(tag) {
                this.other_ip_data1.splice(this.other_ip_data1.indexOf(tag), 1);
                this.other_ip_data2.splice(this.other_ip_data2.indexOf(tag), 1);
                this.getData(this.other_ip_data2)
            },

            showInput() {
                this.inputVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },

            handleInputConfirm() {
                let inputValue = this.inputValue;
                if (inputValue) {
                    this.other_ip_data1.push(inputValue);
                    this.other_ip_data2.push(this.handleData(inputValue))
                    this.getData(this.other_ip_data2)
                }
                this.inputVisible = false;
                this.inputValue = '';
            },
            handleData(val){
                return { ip: val.split("/")[0], hostname: val.split("/")[1] }
            }
        }
    }
</script>

<style scoped >
    /deep/.el-button.otherIpNew {
        margin-left: 10px;
        width: 100px;
        height: 21px;
        line-height: 21px;
        padding-top: 0;
        padding-bottom: 0;
        background-color: #1890ff;
    }
    .el-tag + .el-tag {
        margin-left: 10px;
    }

    .el-input.input-new-tag {
        width: 200px;
        height: 22px;
        line-height: 22px;
        margin-left: 10px;
        vertical-align: center;
    }
    .el-input.input-new-tag input{
        height: 22px;
        line-height: 22px;
    }
</style>
